import { useQuery } from "react-query";
import { getAllTressEmployees } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetAllTressEmployees = () => {
  return useQuery("GetAllTressEmployees", getAllTressEmployees, {
    refetchOnWindowFocus: false,
  });
};
export default useGetAllTressEmployees;
